import { boot } from 'quasar/wrappers';
import 'driver.js/dist/driver.css';

const DRAFT_GUIDES_KEY = 'interactiveGuidesDraftMode';

export const DRIVER_DEFAULTS = {
  animate: true,
  smoothScroll: true,
  allowClose: true,
  overlayOpacity: 0.5,
  stagePadding: 10,
  stageRadius: 5,
  showProgress: true,
  progressText: '{{current}} of {{total}}',
  nextBtnText: 'Next',
  prevBtnText: 'Previous',
  doneBtnText: 'Done',
  popoverClass: 'ugle-tour-popover',
} as const;

export function isDraftGuidesEnabled(): boolean {
  return sessionStorage.getItem(DRAFT_GUIDES_KEY) === 'true';
}

export function setDraftGuidesMode(enabled: boolean): void {
  if (enabled) {
    sessionStorage.setItem(DRAFT_GUIDES_KEY, 'true');
  } else {
    sessionStorage.removeItem(DRAFT_GUIDES_KEY);
  }
}

export default boot(() => {
  const url = new URL(window.location.href);
  const draftGuidesParam = url.searchParams.get('draft_guides');

  if (draftGuidesParam !== null) {
    const enabled = draftGuidesParam.toLowerCase() === 'true';
    setDraftGuidesMode(enabled);

    if (enabled) {
      console.info('[Interactive Guides] Draft mode enabled via query string');
    } else {
      console.info('[Interactive Guides] Draft mode disabled via query string');
    }
  }
});
